import { cn } from '@/shadcn/lib/utils';

import { AvatarComponent } from '@/components/ui/avatar/avatar';

export type SubmitterIdentity = {
  email: string;
  name?: string | null;
  avatar?: string | null;
};

// The batch tables store only an email; account-api supplies the display name.
// An unresolved address falls back to the email rather than rendering blank.
export function submitterLabel(identity: SubmitterIdentity): string {
  return identity.name?.trim() || identity.email;
}

// AvatarComponent derives its initials (and its colour) from whole words, so an
// unresolved address would otherwise render an empty circle.
function avatarName(identity: SubmitterIdentity): string {
  const name = identity.name?.trim();
  if (name) {
    return name;
  }
  return identity.email.split('@')[0].replace(/[._-]+/g, ' ');
}

type Props = {
  identity: SubmitterIdentity;
  className?: string;
  // Reads "by Marie Curie" next to a job's timestamps; off in the filter
  // dropdown, where the name is the option itself.
  withBy?: boolean;
};

/** Avatar + display name for whoever submitted a batch. */
export function BatchSubmitter({ identity, className, withBy = false }: Props) {
  const label = submitterLabel(identity);
  return (
    <span className={cn('flex min-w-0 items-center gap-1.5', className)}>
      {withBy ? <span className="shrink-0">by</span> : null}
      <AvatarComponent
        aria-hidden
        name={avatarName(identity)}
        size={16}
        source={identity.avatar}
      />
      <span className="truncate" title={identity.email}>
        {label}
      </span>
    </span>
  );
}
